module.exports = __webpack_public_path__ + "img/smartphone.cbba44a5.svg";